import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Costumes() {
  return <ImageCollectionPage title="Costumes" path="/culture/costumes" collection="culture_costumes" />;
}
